import RiCheckFill from '@ben/icons/check-fill';
import type { MenuItemProps as MantineMenuItemProps } from '@mantine/core';
import { createPolymorphicComponent, Menu as MantineMenu } from '@mantine/core';
import { memo } from 'react';
import styled, { css } from 'styled-components';
import RIcon from '../remix-icon';

export interface MenuItemProps extends MantineMenuItemProps {
  active?: boolean;
}

const Dropdown = styled(MantineMenu.Dropdown)`
  ${({ theme }) => css`
    border-radius: ${theme.borderRadius.sm};
    border: 1px solid ${theme.palette.neutral[60]};
    background-color: ${theme.palette.neutral['00']};
    box-shadow: 0px 4px 10px 0px ${theme.palette.black(0.1)};
    padding: 0;
  `}
`;
const Label = styled(MantineMenu.Label)`
  ${({ theme }) => css`
    ${theme.typography.bodyMd2}
    padding: ${theme.spacing(1.5, 2)};
  `}
`;

const Divider = styled(MantineMenu.Divider)`
  ${({ theme }) => css`
    background-color: ${theme.palette.neutral[60]};
    height: 1px;
    margin: ${theme.spacing(0, 2)};
  `}
`;

const Item = createPolymorphicComponent<'button', MenuItemProps>(
  ({ active, children, ...rest }: MenuItemProps) => {
    return (
      <StyledMantineMenuItem aria-selected={active} {...rest}>
        {children}
        {active && <RIcon icon={RiCheckFill} />}
      </StyledMantineMenuItem>
    );
  }
);

const StyledMantineMenuItem = createPolymorphicComponent<
  'button',
  MenuItemProps
>(styled(MantineMenu.Item)`
  ${({ theme }) => css`
    padding: ${theme.spacing(1.5, 2)};
    .mantine-Menu-itemLabel {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: ${theme.spacing(1)};
    }
    &:hover,
    &:focus,
    &[data-hovered] {
      background-color: ${theme.palette.neutral[40]};
    }
  `}
`);

export default Object.assign(memo(MantineMenu), {
  Target: MantineMenu.Target,
  Dropdown,
  Item,
  Divider,
  Label,
});
